module.exports = __webpack_public_path__ + "static/media/www.cd07c81e.jpg";